import { Button as Button, Dropdown as Dropdown, ScrollSpy as ScrollSpy, Tab as Tab, Collapse as Collapse } from 'bootstrap';
import '@fortawesome/fontawesome-free/css/all.css';
import Swiper, { Autoplay, Navigation, Pagination, EffectFade } from "swiper";
Swiper.use([Autoplay, Navigation, Pagination, EffectFade]);
import "swiper/swiper-bundle.css";
import AOS from "aos";
import "aos/dist/aos.css";

import './styles.scss';



document.addEventListener("DOMContentLoaded", function () {
  window.addEventListener("scroll", function () {
    if (window.scrollY > 150) {
      document.getElementById("header").classList.add("scrolled");
      document.getElementById("header").classList.remove("closed");
    } else {
      document.getElementById("header").classList.remove("scrolled");
      document.getElementById("header").classList.remove("closed");
    }
  });
});

$( document ).ready( function() {

  AOS.init({
    offset: 120, // offset (in px) from the original trigger point
    delay: 0, // values from 0 to 3000, with step 50ms
    duration: 1000, // values from 0 to 3000, with step 50ms
    easing: "ease", // default easing for AOS animations
    once: true, // whether animation should happen only once - while scrolling down
  });

  $(".burger .burger-button").on("click touch", function (e) {
    e.preventDefault();
    if ($("header").hasClass("open")) {
      $("header").addClass("closed");
    } else {
      $("header").removeClass("closed");
    }
    $("header").toggleClass("open");
    
    $(".burger .burger-button").toggleClass("active");
    $(".header-right").toggleClass("active");
  });

  $(".close-button").on("click touch", function (e) {
    e.preventDefault();
    $("header").removeClass("open");
    $(".burger .burger-button").removeClass("active");
    $(".header-right").removeClass("active");
  });

  if(window.location.hash) {
    var target = window.location.hash;
    $("html, body").animate({ scrollTop: $(target).offset().top - 85 }, 0);
  }

  $(function () {
    $('.current-menu-item a[href*="#"]:not([href="#"])').click(function () {
      if (
        location.pathname.replace(/^\//, "") ==
          this.pathname.replace(/^\//, "") &&
        location.hostname == this.hostname
      ) {
        var target = $(this.hash);
        target = target.length
          ? target
          : $("[name=" + this.hash.slice(1) + "]");
        if (target.length) {

          $("header").removeClass("open");
          $('.burger-button').removeClass("active");
          $(".header-right").removeClass("active");

          $("html, body").animate(
            { scrollTop: $(target).offset().top - 85 },
            0
          );
          return false;
        }
      }
    });
  });

  $('.anchor').on('click touch', function (e) {
    e.preventDefault();
    var target = $(this).attr( 'href' );
    if ($(target).length > 0) {
      $("html, body").animate({ scrollTop: $(target).offset().top - 85 }, 0);
      return false;
    } else {
      $("html, body").animate({ scrollTop: $("#footer").offset().top - 85 }, 0);
      return false;
    }
  });

  
  if ($("#counter-box").length > 0) {
    var a = 0;
    counterFunction();
    $(window).scroll(function () {
      counterFunction();
    });
      
  }

  function counterFunction() {
    var oTop = $("#counter-box").offset().top - window.innerHeight;
    if (a == 0 && $(window).scrollTop() > oTop) {
      $(".counter").each(function () {
        var $this = $(this),
          countTo = $this.attr("data-number");
        $({
          countNum: $this.text(),
        }).animate(
          {
            countNum: countTo,
          },

          {
            duration: 2000,
            easing: "swing",
            step: function () {
              //$this.text(Math.ceil(this.countNum));
              $this.text(Math.ceil(this.countNum).toLocaleString("en"));
            },
            complete: function () {
              $this.text(Math.ceil(this.countNum).toLocaleString("en"));
              //alert('finished');
            },
          }
        );
      });
      a = 1;
    }
  }


  $(".popup-video").magnificPopup({
    type: "iframe",
    mainClass: "mfp-fade",
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false,
  });


  const sliderBlock = new Swiper(".slider_block .swiper", {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 30,
    loopedSlides: 9,
    centeredSlides: true,
    autoplay: {
      delay: 5000
    },
    pagination: {
      el: ".slider_block .swiper-pagination",
      clickable: true
    },
  });


  const timelineBlock = new Swiper(".timeline_block .swiper", {
    loop: false,
    slidesPerView: 1,
    spaceBetween: 20,
    breakpoints: {
      768: {
        slidesPerView: 1.1,
        spaceBetween: 30,
      },
      992: {
        slidesPerView: 1.2,
      },
      1200: {
        slidesPerView: 1.4,
      },
    },
    autoplay: {
      delay: 5000,
    },
    pagination: {
      el: ".timeline_block .swiper-pagination",
      clickable: true,
      dynamicBullets: true,
      dynamicMainBullets: 4,
    },
  });

  const partnersBlock = new Swiper(".partners_block .swiper", {
    loop: true,
    slidesPerView: 3,
    spaceBetween: 20,
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      992: {
        slidesPerView: 4,
      },
      1200: {
        slidesPerView: 6,
      },
      1400: {
        slidesPerView: 7,
      },
      1500: {
        slidesPerView: 8,
      },
    },
    autoplay: {
      delay: 5000,
    },
  });


});